import React from 'react';
import { PromotedLinksProps } from './PromotedLinks.types';
import * as Styles from './PromotedLinks.styles';
import Row from '../../components/Row/Row';
import Column from '../../components/Column/Column';
import DynamicIcon from '../DynamicIcon/DynamicIcon';

const PromotedLinks: React.FC<PromotedLinksProps> = ({ promotedLinksArray, oneCol }) => {
  if (promotedLinksArray.length > 0) {
    return (
      <Styles.PromotedLinks data-testid="PromotedLinks" $oneCol={oneCol}>
        <Row isList hasWrap={true}>
          {promotedLinksArray.map((link, i) => (
            <Column isList small="full" medium="one-half" large="one-third" key={i}>
              <Styles.PromotedLink $oneCol={oneCol} href={link.url} title={link.title}>
                {link.iconKey && <DynamicIcon icon={link.iconKey} level={2} />}
                <span>{link.title}</span>
              </Styles.PromotedLink>
            </Column>
          ))}
        </Row>
      </Styles.PromotedLinks>
    );
  } else {
    return null;
  }
};

export default PromotedLinks;
